<script>
import ActiveIcon from "@/assets/images/misc/green-unlocked.svg";
import InactiveIcon from "@/assets/images/misc/red-locked.svg";

export default {
  name: "VenueCard",
  components:{ActiveIcon , InactiveIcon},
  props: {
    venue: {
      default: null,
    },
  },
  computed: {
    cities() {
      return this.$store.getters.getCities.data;
    },
    cityName() {
      return this.cities.find((city) => city.id === this.venue.city_id)?.name;
    },
  },
  methods: {
    gotoVenuePage(id) {
      this.$router.push({name: "CreateOrUpdateVenue", params: {id: id}});
    },

    activateInactivate(venue){
      this.$emit('confirm-activate',{id:venue.id, status_id:venue.status_id})
    }
  }
}
</script>

<template>
  <div v-if="venue" :class="{'about-to-expire':venue.is_expiring}"  class="shadow bordered rounded-lg p-4 relative pointer"  @click="gotoVenuePage(venue.id)">
    <v-row>
      <v-col md="4" sm="12">
        <view-image
            :image="venue.profile_image"
            class="rounded-lg bordered p-2"
            width="100%"
        />
      </v-col>
      <v-col md="8" sm="12">
        <ActiveIcon v-if="venue.status_id === 1" class="activeIcon"  @click.stop="activateInactivate(venue)"/>
        <InactiveIcon v-if="venue.status_id !== 1" class="activeIcon"  @click.stop="activateInactivate(venue)"/>

        <span class="city-name">
          {{ cityName }}
        </span>
        <h3 class="line-clamp-1 mt-5">
          {{ venue.name }}
        </h3>
        <p class="mb-2 line-clamp-1 text-neon">
          {{ venue.email }}
        </p>
<!--        <div class="d-flex justify-space-between align-center">-->
<!--          <p class="mb-2 text-dark-gray text-sm">Operators</p>-->
<!--          <p class="mb-2 text-sm">-->
<!--            <template >-->
<!--              {{ (venue.users_count || 0)| numberFormatter }}-->
<!--            </template>-->
<!--          </p>-->
<!--        </div>-->
        <div class="d-flex justify-space-between align-center">
          <p class="mb-2 text-dark-gray text-sm">Date Created</p>
          <p class="mb-2 text-sm">
            <template v-if="venue.agreement_start_date">
              {{ venue.agreement_start_date | dateformat }}
            </template>
            <template v-else-if="venue.starts_at">
              {{ venue.starts_at | dateformat }}
            </template>
            <template v-else>
              -
            </template>
          </p>
        </div>
        <div class="d-flex justify-space-between align-center">
          <p class="mb-2 text-dark-gray text-sm">End Date</p>
          <p class="mb-2 text-sm">
            <template v-if="venue.agreement_end_date">
              {{ venue.agreement_end_date | dateformat }}
            </template>
            <template v-else>
              -
            </template>
          </p>
        </div>
      </v-col>
    </v-row>
    <VDivider class="my-4"/>
    <v-row class="text-center">
      <v-col>
        <p class="mb-2 text-dark-gray text-sm">Customers</p>
        <p class="mb-2 text-sm text-blue font-medium">
          {{ (venue.customers_count || 0) | numberFormatter }}
        </p>
      </v-col>
      <v-col>
        <p class="mb-2 text-dark-gray text-sm">Bookings</p>
        <p class="mb-2 text-sm text-blue font-medium">
          {{ (venue.bookings || 0) | numberFormatter }}
        </p>
      </v-col>
      <v-col>
        <p class="mb-2 text-dark-gray text-sm">Sales</p>
        <p class="mb-2 text-sm text-blue font-medium">
          {{ (venue.sales || 0) | toCurrency }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
.about-to-expire{
  background: #ff000026;
}

.city-name {
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 0 0.5rem;
  background: #112A46;
  padding: 5px;
  color: white;
  font-size: 12px;
  min-width: 70px;
  text-align: center;
}

.activeIcon{
  position: absolute;
  right: 70px;
  top: 5px;
  color: #4FAEAF;

}


.inactiveColor{
  color: #FF2D55;
}
</style>